import { Lang } from "@feed-factory/feed-factory.models.lang";
import { ExtLangString, IntLangStrings, Open } from "./Ndtrc";

export interface ExtPromotion {
  promotionType: PromotionType;
  discount: Discount;
  translations: PromotionTranslation[];
  detailsUrls: PromotionDetailsUrl[];
  startDate: string; // date
  endDate: string; // date
  enabled: boolean;
  targetAudiences: PromotionTargetAudience[];
  opens: Open<ExtLangString[]>[];
}

export interface IntPromotion {
  id: string;
  promotionType: PromotionType;
  discount: Discount;
  translations: PromotionTranslation[];
  detailsUrls: PromotionDetailsUrl[];
  startDate: string; // date
  endDate: string; // date
  enabled: boolean;
  targetAudiences: PromotionTargetAudience[];
  opens: Open<IntLangStrings>[];
}

export type PromotionType = "free" | "discount" | "gift" | "allowance";
export const PromotionTypeOptions: { value: PromotionType; label: string }[] = [
  { value: "free", label: "promotionType.free" },
  { value: "discount", label: "promotionType.discount" },
  { value: "gift", label: "promotionType.gift" },
  { value: "allowance", label: "promotionType.allowance" },
];

export type PromotionTargetAudience = "residents" | "visitors";

export interface Discount {
  free: boolean;
  percentage: number; // integer
  amount: number; // double
}
export interface PromotionTranslation {
  lang: Lang;
  description: string;
}
export interface PromotionDetailsUrl {
  lang: Lang;
  url: string;
}
